import { render, staticRenderFns } from "./Suplementar.vue?vue&type=template&id=fd0547de&scoped=true"
import script from "./Suplementar.vue?vue&type=script&lang=js"
export * from "./Suplementar.vue?vue&type=script&lang=js"
import style0 from "./Suplementar.vue?vue&type=style&index=0&id=fd0547de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0547de",
  null
  
)

export default component.exports